export default "__VITE_ASSET__b6Dgo2BR__"